import {ShoppingCartHelper} from "../helpers/shopping_cart/shopping_cart_helper.js";
// Amount choice for the related-products cards (product_preview_card.php).
import "../helpers/shopping_cart/quick_add.js";
import {AddProductToOrderlistModal} from "../helpers/orderlists/add_product_to_orderlist_modal.js";
import {DeleteOrderlistModal} from "../orderlists/delete_modal.js";
import {OrderlistsHelper} from "../helpers/orderlists/orderlists_helper.js";

class productDetailPage {

    constructor() {

        $('#back-to-search-index-btn').click((event) => {

            event.preventDefault();
            if(document.referrer.indexOf('/products') !== -1) {
                window.history.back();
            } else {
                window.location = '/products';
            }
        });

        $('#add-product-to-orderlist-btn').click(() => {
            AddProductToOrderlistModal.showModal(parseInt($('#add-product-to-orderlist-btn').attr('data-product-id')));
        });

        this.relatedProductsSection = $("#related-products-section");

        this._initGallery();
        this._checkAttachmentUrls();

        if($('#manage-product-modal').length > 0) {

            this.manageProductImageModal = $('#manage-product-modal');
            this.emptyImageAlert = $('#manage-product-image-error');
            this.dropzone = new Dropzone('#product-image-dropzone', {
                url: 'test',
                addRemoveLinks: true,
                autoQueue: false,
                autoProcessQueue: false,
                maxFiles: 1,
                createImageThumbnails: true,
                thumbnailWidth: null,
                thumbnailHeight: null,
                dictRemoveFile: "Wijzig afbeelding",
                acceptedFiles: 'image/*'
            });

            this.editProductImageModalBtn = $('#edit-product-modal-btn');
            this.editProductImageModalBtn.click(() => {
                this.editProductImage();
            });

            this.saveDescriptionBtn = $('#save-detail-description-btn');
            this.saveDescriptionBtn.click(() => {
                this.editProductDescription();
            });
        }
    }

    async _initGallery() {
        const mainSwiperEl  = document.getElementById('gallery-swiper');
        const thumbSwiperEl = document.getElementById('gallery-thumbnail-swiper');
        if (!mainSwiperEl) return;

        const mainSlides  = Array.from(mainSwiperEl.querySelectorAll('.gallery-item'));
        const thumbSlides = thumbSwiperEl ? Array.from(thumbSwiperEl.querySelectorAll('.swiper-slide')) : [];

        // Check all slide image URLs in parallel; skip video items (no <img> to check).
        // Use the <a href> attribute (not img.src) because onerror may have already
        // replaced img.src with the fallback placeholder before this code runs.
        const results = await Promise.all(mainSlides.map((slide, idx) => new Promise(resolve => {
            const img = slide.querySelector('img');
            if (!img) return resolve({ idx, ok: true });
            const url = slide.getAttribute('href') || img.getAttribute('src') || '';
            if (!url || url.startsWith('/img/default/')) return resolve({ idx, ok: false });
            const testImg = new Image();
            testImg.onload  = () => resolve({ idx, ok: true });
            testImg.onerror = () => resolve({ idx, ok: false });
            testImg.src     = url;
        })));

        // Remove broken slides in reverse index order to preserve remaining indices
        results
            .filter(r => !r.ok)
            .map(r => r.idx)
            .sort((a, b) => b - a)
            .forEach(idx => {
                if (mainSlides[idx])  mainSlides[idx].remove();
                if (thumbSlides[idx]) thumbSlides[idx].remove();
            });

        // The container is rendered with class "js-product-gallery" rather than
        // "gallery" specifically so theme.js's auto-init (document.querySelectorAll
        // ('.gallery'), which runs before this module and discards the instance it
        // creates with no destroy handle we can reach - no data-lg-uid attribute,
        // no window.lgData registry in this lightGallery version) never sees it and
        // never creates a first instance to begin with. Add "gallery" back now,
        // immediately before our own (only) lightGallery() call below.
        const galleryEl = mainSwiperEl.closest('.js-product-gallery');
        if (galleryEl) {
            galleryEl.classList.add('gallery');

            // Store the instance on the element and destroy any previous one before
            // re-initializing, matching the pattern already used in products/index.js
            // for the same lightGallery-reinit-after-cleanup situation.
            if (galleryEl._lgInstance) {
                galleryEl._lgInstance.destroy();
                galleryEl._lgInstance = null;
            }

            galleryEl._lgInstance = lightGallery(galleryEl, {
                selector:            '.gallery-item',
                plugins:             [lgZoom, lgFullscreen, lgVideo],
                licenseKey:          'D4194FDD-48924833-A54AECA3-D6F8E646',
                download:            false,
                autoplayVideoOnSlide: true,
                zoomFromOrigin:      false,
                youtubePlayerParams: { modestbranding: 1, showinfo: 0, rel: 0 },
                vimeoPlayerParams:   { byline: 0, portrait: 0, color: '6366f1' },
            });
        }

        // Init Swiper only when slides remain
        if (!mainSwiperEl.querySelector('.gallery-item')) return;

        // Hide thumbnail strip (and the <hr> before it) when only 1 slide is left after cleanup
        const remainingSlides = mainSwiperEl.querySelectorAll('.gallery-item').length;
        if (remainingSlides <= 1 && thumbSwiperEl) {
            const hr = thumbSwiperEl.previousElementSibling;
            if (hr && hr.tagName === 'HR') hr.remove();
            thumbSwiperEl.remove();
        }

        // theme.js auto-initializes any ".swiper" element on the page (including
        // these two) before this module runs. Destroy that instance first, same
        // as the lightGallery re-init above, or the new Swiper() calls below stack
        // a second instance on top of it - Swiper wraps/duplicates the slide DOM
        // on each init, which looked like two overlapping galleries.
        // cleanStyles stays false - it strips the *entire* style attribute (not
        // just properties Swiper itself set), which would wipe out any
        // server-rendered inline sizing on these containers (see the same fix
        // on categories/index.js, where that turned out to actually be present).
        if (thumbSwiperEl && thumbSwiperEl.swiper) {
            thumbSwiperEl.swiper.destroy(true, false);
        }
        if (mainSwiperEl.swiper) {
            mainSwiperEl.swiper.destroy(true, false);
        }

        let thumbSwiper = null;
        if (thumbSwiperEl && remainingSlides > 1) {
            thumbSwiper = new Swiper("#gallery-thumbnail-swiper", {
                slidesPerView: 2,
                freeMode: true,
                watchSlidesProgress: true,
                watchOverflow: true,
                navigation: {
                    nextEl: "#gallery-thumbnail-next",
                    prevEl: "#gallery-thumbnail-prev",
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3
                    }
                }
            });
        }
        new Swiper("#gallery-swiper", {
            // Loop mode duplicates slide DOM nodes to create the seamless-wrap
            // illusion, which needs enough real slides to do safely (Swiper's own
            // "not enough slides for loop mode" warning otherwise fires and the
            // half-finished duplication leaves .gallery-item markup in a state
            // lightGallery's video-slide tracking doesn't expect).
            loop: remainingSlides > 2,
            navigation: {
                nextEl: "#gallery-main-next",
                prevEl: "#gallery-main-prev",
            },
            ...(thumbSwiper ? { thumbs: { swiper: thumbSwiper } } : {}),
        });
    }

    _checkAttachmentUrls() {
        const rows = Array.from(document.querySelectorAll('.attachment-row[data-attachment-url]'));
        if (!rows.length) return;

        // Hide all rows immediately and show loader to prevent flicker
        rows.forEach(row => row.style.display = 'none');
        document.getElementById('attachments-loader')?.classList.remove('d-none');

        const urls = [...new Set(rows.map(r => r.getAttribute('data-attachment-url')))];

        $.post('/products/checkUrls', { urls })
            .then(results => {
                rows.forEach(row => {
                    const url = row.getAttribute('data-attachment-url');
                    if (results[url] === false) {
                        row.remove();
                    } else {
                        row.style.display = '';
                    }
                });

                // If the main attachments table is now empty, swap to empty state
                const tableWrapper = document.getElementById('attachments-table-wrapper');
                if (tableWrapper) {
                    const remainingRows = tableWrapper.querySelectorAll('.attachment-row').length;
                    if (remainingRows === 0) {
                        const showMoreBtn = document.querySelector('#attachments-card [data-bs-target="#attachments-modal"]');
                        tableWrapper.remove();
                        if (showMoreBtn) showMoreBtn.remove();
                        document.getElementById('attachments-empty-state')?.classList.remove('d-none');
                    }
                }

                // Update "Toon alle N documenten" button count
                const remaining = document.querySelectorAll('#attachments-modal .attachment-row').length;
                const showAllBtn = document.querySelector('[data-bs-target="#attachments-modal"]');
                if (showAllBtn && remaining <= 10) {
                    showAllBtn.remove();
                } else if (showAllBtn) {
                    showAllBtn.textContent = '';
                    showAllBtn.innerHTML = `Toon alle ${remaining} documenten <i class="ai-arrow-right ms-1"></i>`;
                }
            })
            .catch(() => {})
            .always(() => {
                document.getElementById('attachments-loader')?.classList.add('d-none');
            });
    }

    editProductDescription() {

        const description = $('#detail-description-textarea').val();
        const productId = this.relatedProductsSection.attr('data-product-id');

        this.saveDescriptionBtn.addClass('loading disabled');
        $.post('/products/editDescription', {
            product_id: productId,
            description: description
        })
            .then(() => {
                window.location.reload();
            })
            .catch(() => {
                // TODO
            })
            .always(() => {
                this.saveDescriptionBtn.removeClass('loading disabled');
            });
    }

    editProductImage() {

        const selectedImages = this.dropzone.getAcceptedFiles();

        if(selectedImages.length === 0) {
            this.emptyImageAlert.removeClass('hidden');
        } else {
            this.emptyImageAlert.addClass('hidden');

            const postData = new FormData();
            postData.append('image', selectedImages[0]);
            postData.append('product_id', $('#related-products-section').attr('data-product-id'));

            this.editProductImageModalBtn.addClass('loading disabled');
            $.ajax({
                url: '/Products/editImage',
                data: postData,
                processData: false,
                contentType: false,
                type: 'POST'
            })
                .then((response) => {

                    this.dropzone.removeAllFiles();
                    this.manageProductImageModal.modal('hide');
                    window.location.reload();
                })
                .catch((error) => {

                    // TODO
                })
                .always(() => {
                    this.editProductImageModalBtn.removeClass('loading disabled');
                });
        }
    }
}

export let ProductDetailPage = new productDetailPage();
